import { InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { EntityMeta } from '../../base/EntityMeta'
import type { DocumentLink } from '../DocumentLink'

@InputType()
export class GetDocumentLinksArgs extends ActionArgs {
  filter?: unknown
  options?: unknown
}

export interface IGetDocumentLinks extends IAction<DocumentLink[], GetDocumentLinksArgs> {}
export interface IGetDocumentLinksMeta extends IAction<EntityMeta, GetDocumentLinksArgs> {}
